<template>
  <div>
    <div
      class="share-icon"
      @click.prevent="sharePopup"
    >
      <i class="fas fa-share-alt"></i>
      share
    </div>
    <ShareModal
      :item="exItem"
      name="User"
      :has_episode="has_episode"
      @closeModal="closeShareModal"
      v-if="exItem"
    />
  </div>
</template>

<script>
import axios from 'axios';

import ShareModal from './creator/components/share-modal';
import decrypt from './decrypt';

export default {
  name: 'share-icon',
  props: ['item', 'has_episode', 'decryptKey'],
  components: {
    ShareModal,
  },
  data() {
    return {
      exItem: null,
    };
  },
  mounted() {
    this.decryptItem(this.item)
      .then((response) => {
        this.exItem = decrypt(response.data.item);
      })
      .catch((error) => {
        console.error('Decryption failed:', error);
      });
  },
  methods: {
    sharePopup() {
      $(`#shareModal${this.exItem.id}`).modal('show');
    },
    closeShareModal() {
      $(`#shareModal${this.exItem.id}`).modal('hide');
    },
    decryptItem(item) {
      const apiUrl = `/decrypt-item`;
      return axios.post(apiUrl, {
          item: item,
      });
    },
  },
};
</script>

<style scoped>
.share-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  padding: 5px 15px;
  background-color: var(--color-grayish);
  color: #fff;
  margin-right: 7px;
}

.share-icon:hover {
  cursor: pointer;
  background-color: var(--bg-hover-color);
}

@media screen and (max-width: 360px) {
  .share-icon {
    padding: 5px 8px;
    font-size: 10px !important;
    margin-left: 0.5rem;
  }
}
.share-icon:hover {
  cursor: pointer;
}
.share-icon i {
  margin-right: 5px;
}
</style>
